import React from 'react';
import { withFormsy } from 'formsy-react';
import { IconButton } from '@mui/material';

import BaseTextField, { type FieldProps } from './components/BaseTextField';
import Icon from '../Icon';

type LinkTextFieldProps = {
	/** The icon name */
	icon: string;
	/** Function executed when the icon is pressed */
	onIconClick?: React.MouseEventHandler<HTMLButtonElement>;
} & Omit<FieldProps<string>, 'startAdornment' | 'endAdornment'>;

/** A component used to display a link */
function LinkTextField(props: LinkTextFieldProps) {
	function handleChange(event) {
		if (props.beforeChange) props.beforeChange(event.target.value);
		props.sendChange(event.target.name, event.target.value);
		if (props.afterChange) props.afterChange(event.target.value);
	}

	function handleKeyDown(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			handleChange(event);
		}
	}

	return (
		<BaseTextField
			className={props.className}
			name={props.name}
			defaultValue={props.value || ''}
			label={props.label}
			isEdit={props.isEdit}
			startAdornment={<Icon icon={props.icon} />}
			endAdornment={
				!props.isEdit &&
				props.value && (
					<IconButton onClick={props.onIconClick}>
						<Icon icon="open-in-new" />
					</IconButton>
				)
			}
			required={props.required}
			errorMessage={props.errorMessage}
			isFormSubmitted={props.isFormSubmitted}
			isPristine={props.isPristine}
			isValid={props.isValid}
			logProps={props.logProps}
			onChange={event => props.setValue(event.target.value)}
			onBlur={handleChange}
			onKeyDown={handleKeyDown}
		/>
	);
}

export default React.memo(withFormsy(LinkTextField));
